// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2_aPl","footer":"ModalUpdate_footer__1JwVa"};